import React, { useState } from "react";
import "./Navbar.css";
import { motion, AnimatePresence } from "framer-motion";
import { HiOutlineMenuAlt3, HiX } from "react-icons/hi";
import logo from "../assets/logo.png"

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

const links = [
  { name: "HOME", href: "#home" },
  { name: "ABOUT", href: "#about" },
   { name: "KEY PROJECTS", href: "#projects" },
  { name: "COMPANY PROFILE", href: "#company-profile" },
  { name: "CONTACT", href: "#contact" },
];

  return (
    <>
      <motion.nav
        className="navbar"
        initial={{ y: -80 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <ul className="nav-links">
         {links.map((link, index) => (
  <motion.li
    key={index}
    whileHover={{ y: -3 }}
    transition={{ duration: 0.2 }}
  >
    <a href={link.href}>{link.name}</a>
  </motion.li>
))}
        </ul>

        <motion.div
          className="menu-btn"
          whileTap={{ scale: 0.9 }}
          onClick={() => setMenuOpen(true)}
        >
          <HiOutlineMenuAlt3 />
        </motion.div>
      </motion.nav>

      <AnimatePresence>
        {menuOpen && (
          <>
            <motion.div
              className="overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setMenuOpen(false)}
            />

            <motion.div
              className="mobile-menu"
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ duration: .5 }}
            >
              <div className="close-btn" onClick={() => setMenuOpen(false)}>
                <HiX />
              </div>

             {links.map((link, index) => (
  <motion.a
    key={index}
    href={link.href}
    initial={{ opacity: 0, x: 50 }}
    animate={{ opacity: 1, x: 0 }}
    exit={{ opacity: 0, x: 50 }}
    transition={{ delay: index * 0.08 }}
    onClick={() => setMenuOpen(false)}
  >
    {link.name}
  </motion.a>
))}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;